export const MAX_SECONDARY_DIAGNOSES = 24;

export const CODING_VISIT_TYPE_OPTIONS = [
  { value: 'SOC', label: 'SOC' },
  { value: 'ROC', label: 'ROC' },
  { value: 'REC', label: 'Recert' },
  { value: 'SOCPT', label: 'SOC (PT)' },
  { value: 'ROCPT', label: 'ROC (PT)' },
  { value: 'RECPT', label: 'Recert (PT)' },
  { value: 'SOCOT', label: 'SOC (OT)' },
  { value: 'ROCOT', label: 'ROC (OT)' },
  { value: 'RECOT', label: 'Recert (OT)' },
  { value: 'SOCST', label: 'SOC (ST)' },
  { value: 'ROCST', label: 'ROC (ST)' },
  { value: 'RECST', label: 'Recert (ST)' },
];

export const CODING_VISIT_TYPE_LABELS: Record<string, string> =
  Object.fromEntries(
    CODING_VISIT_TYPE_OPTIONS.map(({ value, label }) => [value, label])
  );
